module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_fm"
  }, [_c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e322"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e322"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_alb"
    }
  }, [_vm._v("Recent Titles by Marcia Talley")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e363"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e363"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dcdcdf24a954e-d1e32"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dcdcdf24a954e-d1e32"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_cop"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e445"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e445"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e454"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e454"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e479"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e479"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_epi"
    }
  }, [_vm._v("Epigraph")])])]), _c('div', {
    staticClass: "toc_body"
  }, [_c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e529"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e529"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e747"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e747"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap002"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e935"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e935"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1069"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1069"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1256"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1256"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1421"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1421"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1571"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1571"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1811"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1811"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1956"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e1956"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2105"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2105"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2243"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2243"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2424"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2424"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2585"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2585"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2994"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e2994"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3139"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3139"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3240"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3240"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3368"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3368"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3484"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3484"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3671"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3671"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3830"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e3830"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4110"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4110"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4361"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4361"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4544"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4544"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4714"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4714"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4783"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4783"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4935"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e4935"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5097"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5097"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5248"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5248"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5330"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5330"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5423"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5423"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5618"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5618"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5883"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d57691ac4acf6-d1e5883"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106519_epub_chap032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ad8203","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106519_epub_itoc.vue
// module id = 60
// module chunks = 0